<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
             <el-col :span="6" :xs="24" :sm="12" :md="6">
                <el-form-item label="生产时间" prop="datelist">
                <el-date-picker v-model="searchform.datelist" style="width: 100%" type="daterange"
                  value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" />
              </el-form-item>
            </el-col>
            <el-col :span="6" :xs="24" :sm="12" :md="6">
              <el-form-item label="工厂" prop="factoryCode">
                <el-select v-model="searchform.factoryCode" type="text" filterable style="width: 100%"
                  @change="getworkshoplistsearch(searchform.factoryCode)">
                  <el-option v-for="(item, index) in factorylist" :key="index" :label="item.factory_name"
                    :value="item.factory_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" :xs="24" :sm="12" :md="6">
              <el-form-item label="车间" prop="workshopCode">
                <el-select v-model="searchform.workshopCode" type="text" filterable style="width: 100%"
                  @change="getworklinelistlistsearch(searchform.workshopCode)">
                  <el-option v-for="(item, index) in workshoplist" :key="(item, index)" :label="item.workshop_name"
                    :value="item.workshop_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" :xs="24" :sm="12" :md="6">
                <el-form-item label="产线" prop="worklineCode">
                <el-select v-model="searchform.worklineCode" type="text" filterable style="width: 100%">
                  <el-option v-for="(item, index) in worklinelist" :key="index" :label="item.workline_name"
                    :value="item.workline_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" :xs="24" :sm="12" :md="6">
              <el-form-item label="生产班组" prop="workgroup_name">
                <el-input v-model="searchform.workgroup_name" style="width:100%" clearable placeholder="请输入生产班组" />
              </el-form-item>
            </el-col>
            <el-col :span="6" :xs="24" :sm="12" :md="6">
              <el-form-item label="数据状态" prop="workorder_status">
                <el-select v-model="searchform.workorder_status" type="text" style="width: 100%">
                  <el-option v-for="item in workorder_status" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1" :xs="24" :sm="12" :md="8">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['barter_select']">搜索</el-button>
              <el-button v-permission="['barter_export']" :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>生产数据明细表</h4>
          <el-divider></el-divider>
            <el-table id="parent" v-loading="listLoading" :stripe="true" element-loading-text="拼命加载中" :data="tableData"
            style="width: 100% " :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }" border
            :default-sort="{ prop: 'produce_time', order: 'descending' }" max-height="500">
            <!-- sortable -->
            <el-table-column v-for="item in tablecolumn" :key="item.key" :prop="item.key" :label="item.label"
              :fixed="item.key == 'cz' ? 'right' : false" :min-width="item.width">
            </el-table-column>
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange" @size-change="pagesize" :page-size="3"
            :current-page.sync="currentPage" :page-sizes="[3,5,10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  orderquery,
  factorylist,
  worklinelist,
workshoplist,
} from "@/api/plant";
export default {
  name: "ProductionList",

  data() {
    return {
      //基础数据
      listLoading: false,
      searchform:{
        pageIndex: 1,
        pageSize: 3,
        datelist: [],
        workorder_status:0,
        factoryCode: null,
        worklineCode:null,
        workgroup_name:null,
        workshopCode:null,
      },
      tableData: [],
      // 分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      tablerow: [],
      tablecolumn: [
        {
          label: "工厂",
          key: "factory_code",
          width: "130",
        },
        {
          label: "车间",
          key: "workshop_code",
          width: "130",
        },
        {
          label: "产线",
          key: "workline_code",
          width: "130",
        },
        {
          label: "班组",
          key: "workgroup_code",
        },
        {
          label: "订单",
          key: "orderno",
          width: "100",
        },
        {
          label: "产品",
          key: "product_name",
          width: "200",
        },
        {
          label: "规格",
          key: "specs",
          width: "80",
        },
        {
          label: "计划生产数量",
          key: "product_quantity",
          width: "100",
        },
        {
          label: "人工确认数量",
          key: "reality_instorage_count",
          width: "100",
        },
        {
          label: "批次号",
          key: "batchno",
          width: "160",
        },
        {
          label: "有效期",
          key: "period_date",
          width: "100",
        },
        {
          label: "1级采集数量",
          key: "package_level1_count",
          width: "90",
        },
        {
          label: "1级生产数量",
          key: "package_level1_produce",
          width: "90",
        },
        {
          label: "1级采集率",
          key: "harvest_rate1",
          width: "80",
        },
        {
          label: "2级采集数量",
          key: "package_level2_count",
          width: "90",
        },
        {
          label: "2级生产数量",
          key: "package_level2_produce",
          width: "90",
        },
        {
          label: "2级采集率",
          key: "harvest_rate2",
          width: "80",
        },
        {
          label: "3级采集数量",
          key: "package_level3_count",
          width: "90",
        },
        {
          label: "3级生产数量",
          key: "package_level3_produce",
          width: "90",
        },
        {
          label: "3级采集率",
          key: "harvest_rate3",
          width: "80",
        },
        {
          label: "4级采集数量",
          key: "package_level4_count",
          width: "90",
        },
        {
          label: "4级生产数量",
          key: "package_level4_produce",
          width: "90",
        },
        {
          label: "4级采集率",
          key: "harvest_rate4",
          width: "90",
        },
        {
          label: "5级采集数量",
          key: "package_level5_count",
          width: "90",
        },
        {
          label: "5级生产数量",
          key: "package_level5_produce",
          width: "90",
        },
        {
          label: "5级采集率",
          key: "harvest_rate5",
          width: "80",
        },
        {
          label: "生产开始时间",
          key: "produce_time",
          width: "160",
        },
        {
          label: "工单完成时间",
          key: "complete_time",
          width: "160",
        },
        {
          label: "计划开始时间",
          key: "plan_datetime1",
          width: "160",
        },
        {
          label: "计划完成时间",
          key: "plan_datetime2",
          width: "160",
        },
        {
          label: "计划生产日期",
          key: "plan_date",
          width: "160",
        },
        {
          label: "生产状态",
          key: "statusname",
          width: "160",
        },
        {
          label: "质检状态",
          key: "quality_statusmean",
          width: "160",
        },
      ],
      orderstatus: [
        {
          value: 1,
          label: "未下载",
        },
        {
          value: 2,
          label: "已下载",
        },
        {
          value: 3,
          label: "生产中",
        },
        {
          value: 4,
          label: "已完成",
        },
        {
          value: 9,
          label: "已关闭",
        },
      ],
      workorder_status: [
        {
          value: 0,
          label: "新数据",
        },
        {
          value: 1,
          label: "历史数据",
        },
      ],
      factorylist: [],
      workshoplist: [],
      worklinelist:[],
      codearr:[],
            // 导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "工单列表",
      autoWidth: true,
      bookType: "xlsx",
    };
  },
  mounted() {
          // 工厂下拉
    factorylist({ pageSize: 10000 }).then((response) => {
      console.log(response.data);
      this.factorylist = response.data.data;
      for (let c = 0; c < this.factorylist.length; c++) {
        this.factorylist[c].factory_name =
          this.factorylist[c].factory_code +
          "|" +
          (this.factorylist[c].factory_sub_code || "") +
          "|" +
          this.factorylist[c].factory_name;
        this.factorylist[c].factory_code =
          this.factorylist[c].factory_code +
          "|" +
          (this.factorylist[c].factory_sub_code || "");
      }
    });
    //请求部门列表数据并且便利到表格
    this.Tabledata({pageIndex:this.searchform.pageIndex,pageSize:this.searchform.pageSize});
    this.getworkshoplistsearch("");
  },
  methods: {
    packdate(obj) {
      // 拼表格数据
      for (let i = 0; i < obj.length; i++) {
        obj[i].harvest_rate1 = obj[i].package_level1_produce == 0 ? '0%' : (obj[i].package_level1_count / obj[i].package_level1_produce * 100).toFixed(2) + "%";
        obj[i].harvest_rate2 = obj[i].package_level2_produce == 0 ? '0%' : (obj[i].package_level2_count / obj[i].package_level2_produce * 100).toFixed(2) + "%";
        obj[i].harvest_rate3 = obj[i].package_level3_produce == 0 ? '0%' : (obj[i].package_level3_count / obj[i].package_level3_produce * 100).toFixed(2) + "%";
        obj[i].harvest_rate4 = obj[i].package_level4_produce == 0 ? '0%' : (obj[i].package_level4_count / obj[i].package_level4_produce * 100).toFixed(2) + "%";
        obj[i].harvest_rate5 = obj[i].package_level5_produce == 0 ? '0%' : (obj[i].package_level5_count / obj[i].package_level5_produce * 100).toFixed(2) + "%";


        if (obj[i].min_package_unit_name) {
          obj[i].product_quantity =
            obj[i].product_quantity + obj[i].product_unit_cn;
        }

        // 把数据按规则拼起来  +'-' (obj[i].factory_sub_code||" ")
        obj[i].produce_time = this.$parseTime(obj[i].produce_time);
        obj[i].complete_time = obj[i].complete_time.replace(/T/, " ");
        obj[i].plan_date = obj[i].plan_date.replace(/T/, " ");
        obj[i].plan_datetime1 = obj[i].plan_datetime1.replace(/T/, " ");
        obj[i].plan_datetime2 = obj[i].plan_datetime2.replace(/T/, " ");
        obj[i].factory_code =
          (obj[i].factory_code || " ") +
          " " +
          (obj[i].factory_sub_code || " ") +
          " " +
          (obj[i].factory_name || " ");
        obj[i].workshop_code =
          (obj[i].workshop_code || " ") + (obj[i].workshop_name || " ");
        obj[i].workgroup_code =
          (obj[i].workgroup_code || " ") + (obj[i].workgroup_name || " ");
        obj[i].workline_code =
          (obj[i].workline_code || " ") + (obj[i].workline_name || " ");
        obj[i].product_name =
          (obj[i].product_code || " ") + " " + (obj[i].product_name || " ");
        obj[i].supplier_id = (obj[i].supplier_id || " ") + (obj[i].supplier_name || " ");
        if (obj[i].period_date == "0001-01-01") {
          obj[i].period_date = " ";
        }
        // 状态为已完成 才有完成时间
        if (obj[i].order_status !== 4) {
          obj[i].complete_time = " ";
        }
        if (obj[i].order_status < 3) {
          // 未生产  生产时间为空
          obj[i].produce_time = " ";
        }
        switch (obj[i].quality_status) {
          case 0:
            obj[i].quality_statusmean = "待质检";
            break;
          case 1:
            obj[i].quality_statusmean = "检验不合格";
            break;
          case 2:
            obj[i].quality_statusmean = "检验合格";
            break;
          default:
            break;
        }
        switch (obj[i].order_status) {
          case 1:
            obj[i].statusname = "未下载";
            break;
          case 2:
            obj[i].statusname = "已下载";
            break;
          case 3:
            obj[i].statusname = "生产中";
            break;
          case 4:
            obj[i].statusname = "已完成";
            break;
          case 9:
            obj[i].statusname = "已关闭";
            break;
          default:
            break;
        }
      }
    },
    Tabledata(obj) {
      // 列表获取
      this.listLoading = true;
      orderquery(obj).then((response) => {
        this.tableData = response.data.data;
        this.packdate(this.tableData);
        this.currentPage = response.data.page_index;
        this.total_count = response.data.total_count;
        this.listLoading = false;
        console.log(response.data);
      });
    },
        // 搜索车间下拉
    getworkshoplistsearch(value) {
      this.searchform.workshopCode = "";
      this.searchform.worklineCode = "";
      this.codearr = value.split("|"); // 把工厂下拉gey 对应工厂编码跟子编码拆开存数组
      workshoplist({
        factory_code: this.codearr[0] || null,
        factory_sub_code: this.codearr[1] || null,
        pageSize: 1000,
      }).then((response) => {
        this.workshoplist = response.data.data;
        for (let i = 0; i < this.workshoplist.length; i++) {
          this.workshoplist[i].workshop_name =
            this.workshoplist[i].workshop_code + "|" + this.workshoplist[i].workshop_name;
        }
      });
    },
    // 产线下拉
    getworklinelistlistsearch(value) {
      this.searchform.worklineCode = "";
      worklinelist({ workshop_code: value, pageSize: 1000 }).then((response) => {
        this.worklinelist = response.data.data;
        for (let b = 0; b < this.worklinelist.length; b++) {
          this.worklinelist[b].workline_name =
            this.worklinelist[b].workline_code + "|" + this.worklinelist[b].workline_name;
        }
      });
    },
          // 重置按钮
    resetForm(formName) {

      this.codearr = []
      this.$refs[formName].resetFields();
    },
      // 搜索事件
    search() {
      this.Tabledata({
        factoryCode: this.codearr[0] || null,
        worklineCode: this.searchform.worklineCode,
        workgroup_name:this.searchform.workgroup_name,
        create_start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        pageSize: this.searchform.pageSize,
      });
    },

       // 分页跳转事件
    currentchange(page_index) {
      this.searchform.pageIndex = page_index;
      this.Tabledata({
        pageIndex: this.searchform.pageIndex,
        pageSize: this.searchform.pageSize,
      });
    },
    // 分页每页显示条数事件
    pagesize(page_size) {
      this.searchform.pageSize = page_size;
      this.search();
    },
    // 导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        productCode: this.searchform.productCode,
        page_index: this.searchform.page_index,
        pageSize: this.total_count,
        workorder_status: this.searchform.workorder_status,
        batchNo: this.searchform.batchNo,
        factoryCode: this.codearr[0] || null,
        factorySubCode: this.codearr[1] || null,
        workshopCode: this.searchform.workshopCode,
        workgroupCode: this.searchform.workgroupCode,
        worklineCode: this.searchform.worklineCode,
        create_start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        line_item_number: this.searchform.line_item_number,
        orderNo: this.searchform.orderNo,
        status: this.searchform.status,
      };
      orderquery(obj).then((response) => {
        this.tableDataDownload = response.data.data;
        this.packdate(this.tableDataDownload);
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "工厂",
            "车间",
            "产线",
            "班组",
            "ERP行号",
            "订单",
            "产品",
            "计划生产数量",
            "人工确认数量",
            "批次号",
            "有效期",
            "1级采集数量",
            "1级生产数量",
            "1级采集率",
            "2级采集数量",
            "2级生产数量",
            "2级采集率",
            "3级采集数量",
            "3级生产数量",
            "3级采集率",
            "4级采集数量",
            "4级生产数量",
            "4级采集率",
            "5级采集数量",
            "5级生产数量",
            "5级采集率",
            "生产开始时间",
            "工单完成时间",
            "计划开始时间",
            "计划完成时间",
            "计划生产日期",
            "生产状态",
            "质检状态",
          ];
          const filterVal = [
            "factory_code",
            "workshop_code",
            "workline_code",
            "workgroup_code",
            "line_item_number",
            "orderno",
            "product_name",
            "product_quantity",
            'reality_instorage_count',
            "batchno",
            "period_date",
            "package_level1_count",
            "package_level1_produce",
            "harvest_rate1",
            "package_level2_count",
            "package_level2_produce",
            "harvest_rate2",
            "package_level3_count",
            "package_level3_produce",
            "harvest_rate3",
            "package_level4_count",
            "package_level4_produce",
            "harvest_rate4",
            "package_level5_count",
            "package_level5_produce",
            "harvest_rate5",
            "produce_time",
            "complete_time",
            "plan_datetime1",
            "plan_datetime2",
            "plan_date",
            "statusname",
            "quality_statusmean",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          // 🛡️ 防御：确保每行数据长度和表头一致
            if (data.length > 0 && data[0].length !== tHeader.length) {
              this.$message.error('数据结构异常：列数不匹配，请刷新重试',data[0].length,tHeader.length );
             console.log('数据结构异常：列数不匹配，请刷新重试',data[0],tHeader );
              this.downloadLoading = false;
              return;
            }
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.handle-box {
  margin-bottom: 0px;
}

.handle-input {
  width: 160px;
  display: inline-block;
}

.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}

.mr10 {
  margin-right: 10px;
}

#parent {
  text-align: center;
}
</style>
